import client from "@/api/client";
import { DonationApiClient } from "../../../cbi-generator/frontend/api/DonationApiClient";
import { DonationFrontendService } from "../../../cbi-generator/frontend/services/DonationFrontendService";
import type { MemberDonationOptions } from "../../../cbi-generator/generated/dto/MemberDonationOptions";
import type { DonationFundMember } from "../../../cbi-generator/generated/dto/DonationFundMember";
import type { DonationInitiativeMember } from "../../../cbi-generator/generated/dto/DonationInitiativeMember";

export type DonationFund = DonationFundMember;
export type DonationInitiative = DonationInitiativeMember & {
  contributionsCurrent: number;
};
export type DonationPurpose = Pick<
  DonationFundMember,
  "imageUrl" | "portalDescription"
>;
export type DonationOptions = Omit<MemberDonationOptions, "initiatives"> & {
  initiatives: DonationInitiative[];
};

export function useDonationNew() {
  const service = new DonationFrontendService(new DonationApiClient(client));
  const fetchDonationOptions = async (): Promise<DonationOptions> => {
    const options = await service.purchaseOptionsPublic();
    return {
      ...options,
      funds: [...options.funds].sort(
        (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0),
      ),
      initiatives: options.initiatives
        .map((initiative) => ({
          ...initiative,
          contributionsCurrent:
            options.progress.find(
              (p) => p.initiativeId === initiative.initiativeId,
            )?.contributionsCents ?? 0,
        }))
        .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)),
    };
  };
  return {
    fetchDonationOptions,
    getFilteredFunds: async () =>
      (await fetchDonationOptions()).funds.filter(
        (fund) => fund.showInCheckout,
      ),
    getFilteredInitiatives: async () =>
      (await fetchDonationOptions()).initiatives,
  };
}
